/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCandidateSourcing = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="M9 2.6a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-2 14c0-1.5.388-2.732 1.14-3.58.734-.826 1.936-1.42 3.86-1.42 1.608 0 2.711.415 3.459 1.034l1.01-1.749C12.331 15.052 10.835 14.6 9 14.6c-2.361 0-4.16.748-5.355 2.092C2.47 18.016 2 19.782 2 21.6v1h2v-1zm13-16a2.99 2.99 0 0 0-1.219.258 6.956 6.956 0 0 0-.77-1.847 5 5 0 1 1-1.068 8.546 7.03 7.03 0 0 0 1.201-1.6A3 3 0 1 0 17 5.6zm6 8.946v9.108l-5.884-2.68H15v-3.75h2.116L23 14.547z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCandidateSourcing as CandidateSourcing };
